export const ActionTypes = {
  LOADING: "CREATE_MASTERPLAN_SELECT_JOURNEY_LOADING",
  ERROR: "CREATE_MASTERPLAN_SELECT_JOURNEY_ERROR",
  SUCCESS: "CREATE_MASTERPLAN_SELECT_JOURNEY_SUCCESS",
};
